/**
 * Split Banner JavaScript
 * Handles cookie-based state management and click events
 */

class SplitBanner {
    constructor(container) {
        this.container = container;
        this.cookieName = 'split_banner_selection';
        this.cookieExpiryDays = 30;

        this.init();
    }

    init() {
        this.checkCookieState();
        this.bindEvents();
    }

    /**
     * Check cookie to determine if banner should be in full-width mode
     */
    checkCookieState() {
        const selectedHalf = this.getCookie(this.cookieName);

        if (selectedHalf) {
            this.showFullWidth(selectedHalf);
        }

        // Trigger fade-in after state is applied
        this.fadeIn();
    }

    /**
     * Bind click events to banner halves
     */
    bindEvents() {
        const halves = this.container.querySelectorAll('.split-banner__half');

        halves.forEach(half => {
            half.addEventListener('click', (e) => {
                e.preventDefault();

                const halfType = half.dataset.half;
                const link = half.querySelector('.split-banner__link').href;

                // Set cookie for future visits
                this.setCookie(this.cookieName, halfType, this.cookieExpiryDays);

                // Navigate to the link
                if (link && link !== '#') {
                    window.location.href = link;
                }
            });
        });
    }

    /**
     * Show full-width version of selected half
     */
    showFullWidth(halfType) {
        this.container.classList.add('split-banner--full-width');

        const selectedHalf = this.container.querySelector(
            `.split-banner__half[data-half="${halfType}"]`
        );

        if (selectedHalf) {
            selectedHalf.querySelector('.split-banner__link').href = selectedHalf.querySelector('.split-banner__link').dataset.link;
        }

        // Hide the non-selected half
        const nonSelectedHalf = this.container.querySelector(
            `.split-banner__half:not([data-half="${halfType}"])`
        );

        if (nonSelectedHalf) {
            nonSelectedHalf.style.display = 'none';
        }
    }

    /**
     * Fade in the visible elements
     */
    fadeIn() {
        // Use requestAnimationFrame to ensure DOM updates are complete
        requestAnimationFrame(() => {
            const visibleHalves = this.container.querySelectorAll('.split-banner__half:not([style*="display: none"])');

            visibleHalves.forEach(half => {
                half.classList.add('split-banner__half--visible');
            });
        });
    }

    /**
     * Set cookie with expiration
     */
    setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));

        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    }

    /**
     * Get cookie value
     */
    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }

        return null;
    }

    /**
     * Clear cookie (for testing purposes)
     */
    clearCookie() {
        document.cookie = `${this.cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    }
}

/**
 * Initialize split banners when DOM is ready
 */
document.addEventListener('DOMContentLoaded', () => {
    const splitBanners = document.querySelectorAll('[data-section-type="split-banner"]');

    splitBanners.forEach(banner => {
        new SplitBanner(banner);
    });
});

/**
 * Initialize split banners for dynamic content (AJAX, etc.)
 */
document.addEventListener('shopify:section:load', (event) => {
    const banner = event.target.querySelector('[data-section-type="split-banner"]');

    if (banner) {
        new SplitBanner(banner);
    }
});
